const dialogDrag = {
	bind(el) {
		const dialogHeaderEl = el.querySelector('.konwledge-diog-header-cls');
		var isSwitch = false;
		var disX, disY;
		var startLeft = 0;
		var startTop = 0;
		el.style.overflow = "auto";
		dialogHeaderEl.style.cursor = 'move';
		var moveDown = (evt) => {
			isSwitch = true;
			var ev = evt || window.event;
			console.log(ev)
			startLeft = ev.clientX;
			startTop = ev.clientY;
			disX = ev.clientX = el.offsetLeft;
			disY = ev.clientY = el.offsetTop;

			document.onmousemove = function (evt) {
				var e = evt || window.event;
				if(isSwitch) {
					var left = e.clientX - disX;
					var top = e.clientY - disY;
				}
				if(left <= 0) {
					left = 0;
				} else if (left >= getInner().w - el.offsetWidth) {
					left = getInner().w - el.offsetWidth;
				}

				if(top <= 0) {
					top = 0;
				} else if (top >= getInner().h - el.offsetHeight) {
					top = getInner().h - el.offsetHeight;
				}

				el.style.left = `${left}px`;
				el.style.top = `${top}px`;
			};
			document.onmouseup = function (e) {
				document.onmousemove = null;
				document.onmouseup = null;
				isSwitch = false;
			};
		}
		dialogHeaderEl.onmousedown = moveDown;
	}
}
export default dialogDrag;

function getInner() {
	if (typeof innerHeight == 'undefined') {
		return {
			w: document.documentElement.clientWidth,
			h: document.documentElement.clientHeight
		} //IE浏览器适用
	} else {
		return {
			w: innerWidth,
			h: innerHeight
		} //非IE浏览器适用
	}
}